<div class="contact-us">
  <div class="container heading">
    <h2 class="text-center">Contactez-nous</h2>
    <div class="content">
      <div class="row">
        <div class="col-sm-5">
          <div class="left">
            <div class="logo">
              <span><img src="assets/images/icons/envelope.png" width="59px" alt=""></span>
            </div>
            <p class="info">Nous mettons tout en œuvre pour faciliter votre visite sur notre site et nous
              voulons faire de notre mieux pour
              répondre à vos attentes. Vous pouvez nous écrire directement depuis ce formulaire.
            </p>
            <div class="contact-info wow fadeInUp animated">
              <div class="footer_column contact">
                <hr class="half_space">
                <p>
                  <img src="assets/images/restaurant.svg" style="margin-right: 6px;" width="32px" [alt]="pdv?.name">
                  {{pdv?.name}}
                </p>
                <p class="address">
                  <i class="flaticon-pin"></i>
                  <a href="#" #maplink target="_blank"> {{pdv?.address}}</a>
                </p>
                <p class="phone">
                  <i class="flaticon-phone-on-circle"></i>
                  <a href="tel:{{pdv?.phone}}">{{pdv?.phone}}</a>
                </p>
                <p class="email" *ngIf="pdv?.emailContact">
                  <i class="flaticon-arroba"></i>
                  <a href="mailto:{{pdv?.emailContact}}">
                    <span>
                      {{pdv?.emailContact}}
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-7">
          <div class="right">
            <form *ngIf="!send" id="main-contact-form" name="contact-form">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="text" name="name" [(ngModel)]="contact.name" class="form-control" placeholder="Nom *"
                      (keyUp)="contactErreur.name=false">
                    <span class="required" *ngIf="contactErreur.name">Merci d'incrire votre nom</span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <input type="email" name="email" [(ngModel)]="contact.email" class="form-control" placeholder="E-mail *"
                      (keyUp)="contactErreur.email=false">
                    <span class="required" *ngIf="contactErreur.email">Merci d'incrire un email valide</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <input type="text" name="subject" [(ngModel)]="contact.subject" class="form-control" placeholder="Sujet *"
                  (keyUp)="contactErreur.subject=false">
                <span class="required" *ngIf="contactErreur.subject">Merci d'incrire le sujet de votre message</span>
              </div>
              <div class="form-group">
                <textarea name="message" id="message" [(ngModel)]="contact.message" class="form-control" rows="4"
                  placeholder="Message *" (keyUp)="contactErreur.message=false"></textarea>
                <span class="required" *ngIf="contactErreur.message">Merci d'incrire votre message</span>
              </div>
              <div class="form-group">
                <button type="submit" [disabled]="loader" class="btn-submit" (click)="contactUs()">
                  <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;</ng-container>
                  Envoyer
                </button>
              </div>
            </form>
            <div class="alert alert-success" *ngIf="send">
              Votre message a bien été pris en compte. Nous allons y répondre dans les meilleurs délais.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>